import { ExternalSettings } from "src/app/common/services/external-settings/external-settings.interface";
import { Injectable } from '@angular/core';
import { BankTemplate } from "src/app/common/services/bank-template/bank-template-bean";

@Injectable({
    providedIn: 'root'
})
export class SkinService {

  private static externalSettings: ExternalSettings;

  public static init(externalSettings: ExternalSettings) {
    this.externalSettings = externalSettings;
  }

  public static isSkin_1(): boolean {
    if (!this.externalSettings) return false;
    return this.externalSettings.globalVariables.customerWebSkinType === SkinTypes.SKIN_1;
  }

  public static isSkin_2(): boolean {
    if (!this.externalSettings) return false;
    return this.externalSettings.globalVariables.customerWebSkinType === SkinTypes.SKIN_2;
  }

  public static isSkin_3(): boolean {
    if (!this.externalSettings) return false;
    return this.externalSettings.globalVariables.customerWebSkinType === SkinTypes.SKIN_3;
  }

  public static isSkin_4(): boolean {
    if (!this.externalSettings) return false;
    return this.externalSettings.globalVariables.customerWebSkinType === SkinTypes.SKIN_4;
  }

  public static getSkinType() {
    if (!this.externalSettings) return;
    return this.externalSettings.globalVariables.customerWebSkinType;
  }

  public static isCustomized() {
    return [BankTemplate.FIRST_NATIONAL].includes(this.externalSettings.templates as BankTemplate);
  }
}

export enum SkinTypes {
  SKIN_1 = 1,
  SKIN_2 = 2,
  SKIN_3 = 3,
  SKIN_4 = 4,
}